export const nav = {
    permissao: "lpbuilder.projetos:visualizar",
    section: "LPBuilder",
    title: "ProjetosLP",
    icon: "folder_open",
    route: "/projetos",
    sequence: 1,
};

export default [
    {
        path: "/projetos",
        name: "lpbuilder-projetos",
        component: () => import("./pages/ProjetosPage.vue"),
        meta: {
            requiresAuth: true,
            permissao: "lpbuilder.projetos:visualizar",
        },
    },
];
